import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from '@/router'
import { i18n } from '@/i18n'
import 'vant/lib/index.css';
import { Icon } from 'vant';
import '@vant/touch-emulator';
const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(Icon);
app.use(i18n);

app.mount('#app')
